/**
 * Convert a string to a URL-friendly slug
 * @param text The text to convert to a slug
 * @param options Configuration options
 * @returns The slugified string
 */
export function normalizeId(id: string | null | undefined): string | undefined {
  if (!id) return undefined
  const parsed = parseInt(id, 10)
  if (isNaN(parsed)) return id
  return String(parsed)
}

export function slugify(
  text: string, 
  options?: { 
    lower?: boolean; 
    strict?: boolean; 
    trim?: boolean;
  }
): string {
  let result = text;
  
  // Convert to lowercase if needed
  if (options?.lower) {
    result = result.toLowerCase();
  }
  
  // Trim whitespace if needed
  if (options?.trim) {
    result = result.trim();
  }
  
  // Replace spaces with dashes
  result = result.replace(/\s+/g, '-');
  
  // Remove special characters if strict mode
  if (options?.strict) {
    result = result
      .replace(/[^\w\-]+/g, '') // Remove non-word characters except dashes
      .replace(/\-\-+/g, '-');  // Replace multiple dashes with single dash
  }
  
  return result;
} 